import { Component, OnInit, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MeetingRecordComponent } from 'src/app/components/main/shared/meeting-record/meeting-record.component';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
@Component({
  selector: 'app-credit-user-meeting-record',
  templateUrl: './credit-user-meeting-record.component.html',
  styleUrls: [
    './credit-user-meeting-record.component.css',
    '../../../../../../shared/meeting-record/meeting-record-parent-shell.styles.css',
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MeetingRecordComponent],
})
export class CreditUserMeetingRecordComponent implements OnInit, ComponentCanDeactivate {
  protected activatedRoute = inject(ActivatedRoute);

  @ViewChild(MeetingRecordComponent) childComponent: MeetingRecordComponent;
  meetingableType: 'App\\Models\\User' | 'App\\Models\\CompanyProduct' | 'App\\Models\\PotentialClient' = 'App\\Models\\User';
  meetingableId: number;
  meetingRecordId: number;

  constructor() {
    this.meetingableId = +(this.activatedRoute.parent?.snapshot.paramMap.get('id') as string); // This is the user id
    this.meetingRecordId = +(this.activatedRoute.snapshot.paramMap.get('meeting_record_id') as string); // This is the meeting record id
  }

  ngOnInit(): void {}

  canDeactivate(): Observable<boolean> | boolean {
    return this.childComponent.canDeactivate();
  }
}
